import Icon from '../components/Icon.vue'

Icon.register({"portrait":{"width":384,"height":512,"paths":[{"d":"M336 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V48C384 21.5 362.5 0 336 0zM192 128C227.3 128 256 156.7 256 192S227.3 256 192 256 128 227.3 128 192 156.7 128 192 128zM304 364.8C304 375.4 294 384 281.6 384H102.4C90 384 80 375.4 80 364.8V345.6C80 313.8 110.1 288 147.2 288H152.2C164.5 293.1 177.9 296 192 296S219.6 293.1 231.8 288H236.8C273.9 288 304 313.8 304 345.6V364.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/portrait.js
// module id = igGh
// module chunks = 0